// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2y5Zn","label":"Section_label__3V-tH","contentWrap":"Section_contentWrap__3em8j","footer":"Section_footer__2nb5D","footerInner":"Section_footerInner__1h_8e"};